export default __webpack_public_path__ + "static/media/telegram-icon.b9d20ba7.svg";